export default __webpack_public_path__ + "static/media/new_balance.03f7c1c2.png";